import axios from 'axios';
import { auth, config } from 'config';
import React, { useEffect, useState } from 'react';
import { v4 } from 'uuid';
import { DocumentFrame, DocumentWrapper } from './DocumentView.styled';
import { useSelector } from 'react-redux';
import { selectDocUrl } from '@store/selectors/statement.selector';
import { dispatch } from '@store';
import { clearDocumentUrl } from '@store/actions/document.action';

export default function DocumentView() {
    const [pdf, setPdf] = useState(null);
    const correlationId = v4();
    const token = auth.isNotDefined ? null : auth.getOkta().getAccessToken();
    const docUrl: string = useSelector(selectDocUrl);
    useEffect(() => {
        axios
            .post(
                `${config.env('awsUrl')}/api/v1/selfserv/documents/download/docurl`,
                { docUrl },
                {
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-api-key': `${config.env('xApiKey')}`,
                        'x-correlation-id': correlationId,
                        Authorization: `Bearer ${token}`
                    }
                }
            )
            .then(res => {
                const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
                const pdfUrl = window.URL.createObjectURL(pdfBlob);
                setPdf(pdfUrl);
                dispatch(clearDocumentUrl());
            })
            .catch(err => {
                console.log(err);
                dispatch(clearDocumentUrl());
            });
    }, []);

    useEffect(() => {
        if (pdf) {
            window.open(pdf, '_self');
        }
    }, [pdf]);
    return <></>;
}
